import React from 'react';
import { useSelector } from 'react-redux';

// components
import { Radio, YesNo } from '../components/inputs';
import { FormRow } from '../components/layout';
import SendShopperEmail from './SendShopperEmail';
import SendShopperSMS from './SendShopperSMS';
import InPersonAgreements from './InPersonAgreements';
import UpdateShopper from './UpdateShopper';

function Attest() {
  const { signature_type: signatureType } = useSelector(store => store.values);
  const { dob, homePhone, mobilePhone } = useSelector(store => store.shopper);

  const shopperHasRequiredData = ((homePhone || mobilePhone) && Boolean(dob));

  return (
    <div>
      <FormRow>
        <Radio
          label="Signature Type"
          name="signature_type"
          unsetFieldsOnCondition={{
            condition: (signatureType === 'in_person'),
            fieldsToUnset: [ 'esign_signature', 'esign_agree' ],
          }}
        />
      </FormRow>
      {(signatureType === 'email') && (
        shopperHasRequiredData ? <SendShopperEmail /> : <UpdateShopper />
      )}
      {(signatureType === 'sms') && (
        shopperHasRequiredData ? <SendShopperSMS /> : <UpdateShopper />
      )}
      {(signatureType === 'in_person') && (
        <InPersonAgreements />
      )}
      {(signatureType === 'voice') && (
        <FormRow>
          <YesNo name="esign_voice_signature" />
        </FormRow>
      )}
    </div>
  );
}

export default Attest;
